import { CreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/CreateTermineFormContext';
import { useCreateTermineForm } from '@/domain/termine/features/CreateTermin/shared/hooks/useCreateTermineForm';
import { ReactNode, useMemo } from 'react';

interface CreateTermineFormProviderProps {
  children: ReactNode;
}

export function CreateTermineFormProvider({
  children,
}: CreateTermineFormProviderProps) {
  const formTanstackForm = useCreateTermineForm();
  const contextValue = useMemo(
    () => ({ form: formTanstackForm }),
    [formTanstackForm],
  );

  return (
    <CreateTermineFormContext.Provider value={contextValue}>
      <form
        className="h-full"
        onSubmit={(e) => {
          e.preventDefault();
          contextValue.form.handleSubmit();
        }}>
        {children}
      </form>
    </CreateTermineFormContext.Provider>
  );
}
